<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='gameModes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseMode')",
                        v-model='selectedGameMode',
                        @select='params.mode = $event.mode'
                    )
            template(v-for="(example, index) in selectedNumOfExamples.length")
                .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                    .form__field-body.form__field-body--inline
                        cs-spin-input(
                            v-model="selectedNumOfExamples[index]"
                            :min="1"
                            :max="availableNumOfExamples[index]"
                            @increase="changeNumOfExamples(index, '+')"
                            @decrease="changeNumOfExamples(index, '-')"
                        )
                        .remove-icon(v-if="selectedNumOfExamples.length > 1" @click="removeExamples(index)")
                            svg-icon(name="cancel", size="x-large")
                .form__field(v-if="gameMode !== 'course'")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_themesForExample', {index})}}
                    .form__field-body.form__field-body--inline.form__field-body--inline-md
                        .form__multiselect-container
                            cs-multiselect(
                                :multiple='false',
                                :options='themes',
                                :show-labels='false',
                                :allow-empty='false',
                                track-by='name',
                                label='name',
                                :class="{'is-danger': errors.has('firstTheme' + index)}"
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseTheme')",
                                :data-vv-name=`'firstTheme' + index`
                                v-validate=`{ is_not:  selectedThemes[index].second }`
                                v-model='selectedThemes[index].first',
                                @select="selectTheme($event, index, 'first')"
                            )
                            help-text(v-if="errors.has('secondTheme' + index) || errors.has('firstTheme' + index)" :error="true")
                                | {{ $i18n.t('trainer.trainer_fourthOneWarning_themes') }}
                        .form__multiselect-container
                            cs-multiselect(
                                :multiple='false',
                                :options='themes',
                                :show-labels='false',
                                :allow-empty='false',
                                track-by='name',
                                label='name',
                                :class="{'is-danger': errors.has('secondTheme' + index)}"
                                :data-vv-name=`'secondTheme' + index`
                                v-validate=`{ is_not:  selectedThemes[index].first }`
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseTheme')",
                                v-model='selectedThemes[index].second',
                                @select="selectTheme($event, index, 'second')"
                            )
                            help-text(v-if="errors.has('secondTheme' + index) || errors.has('firstTheme' + index)" :error="true")
                                | {{ $i18n.t('trainer.trainer_fourthOneWarning_themes') }}
            .form__field
                .form__label
                .form__body
                    cs-button(
                        @click="addExamples()"
                        :disabled="availableNumOfExamples[selectedNumOfExamples.length + 1]"
                    )
                        | Добавить примеры
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode' :disabled="someThemePairsAreEqual || someThemesNotSettled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame' :disabled="someThemePairsAreEqual || someThemesNotSettled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame' :disabled="someThemePairsAreEqual || someThemesNotSettled")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    import { mapState } from 'vuex';
    import { cloneDeep, sum } from 'lodash';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import fourthOneGameApi from '../../../api/games/fourthOneGameApi';

    export default {
        props: {
            slug: String,
            courseType: String,
            id: [Number, String],
            usersIds: [Array, String],
            homeworkId: [Number, String],
            gameMode: String,
            gameId: [Number, String],
            generatorGameIndex: Number,
            generatorSettings: Boolean,
            levelAnswerDuration: Number,
        },
        mixins: [GameFormMixin, multiplayerFormMixin],
        data() {
            return {
                gameModes: [
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSetting_images'),
                        mode: 'images',
                    },
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSetting_words'),
                        mode: 'words',
                    },
                ],
                selectedGameMode: { name: this.$i18n.t('trainer.trainer_gameFormSetting_images'), mode: 'images' },
                allThemes: [],
                selectedThemes: [{ first: '', second: '' }],
                selectedNumOfExamples: [1],
                params: null,
            };
        },
        mounted() {
            this.setThemes();
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    this.params = cloneDeep(TrainerGames.games).find(
                        item => item.slug === this.slug
                    ).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedGameMode = this.gameModes.find(item => item.mode === this.params.mode);
            this.$nextTick(() => {
                const themes = this.params.themes.reduce((result, theme) => {
                    let tempArray = result.filter(
                        value => value.first === theme.first && value.second === theme.second
                    );
                    result = result.filter(
                        value => value.first !== theme.first || value.second !== theme.second || Array.isArray(value)
                    );
                    tempArray.length && result.push(tempArray);
                    return result;
                }, _.cloneDeep(this.params.themes));
                if (themes.length) {
                    this.selectedNumOfExamples = themes.map(value => value.length);
                    this.selectedThemes = themes.map(value => {
                        value = value[0];
                        return {
                            first: {
                                name: this.$i18n.t('trainer.trainer_gameFormSettingValue_' + value.first),
                                key: value.first,
                            },
                            second: {
                                name: this.$i18n.t('trainer.trainer_gameFormSettingValue_' + value.second),
                                key: value.second,
                            },
                        };
                    });
                }
            });
        },
        updated() {
            this.selectedGameMode = this.gameModes.find(item => item.mode === this.params.mode);
            this.$nextTick(() => {
                this.params.numOfExamples = sum(this.selectedNumOfExamples);
                this.params.themes = [];
                this.selectedNumOfExamples.forEach((example, index) => {
                    this.params.themes = [
                        ...this.params.themes,
                        ...Array.from(Array(example), () => {
                            return {
                                first: this.selectedThemes[index].first ? this.selectedThemes[index].first.key : '',
                                second: this.selectedThemes[index].second ? this.selectedThemes[index].second.key : '',
                            };
                        }),
                    ];
                });
            });
        },
        watch: {
            selectedGameMode(val) {
                if (val) {
                    this.selectedThemes = this.selectedThemes.map(() => {
                        return { first: '', second: '' };
                    });
                    this.$nextTick(() => {
                        this.errors.items = this.errors.items.filter(item => item.rule !== 'is_not');
                    });
                }
            },
        },
        methods: {
            setThemes() {
                fourthOneGameApi
                    .getThemes()
                    .then(themes => {
                        this.allThemes = themes.map(theme => {
                            return {
                                name: this.$i18n.t('trainer.trainer_gameFormSettingValue_' + theme.topic),
                                key: theme.topic,
                                type: theme.type,
                            };
                        });
                    })
                    .catch(() => {
                        this.allThemes = [];
                    });
            },
            addExamples() {
                this.selectedNumOfExamples.push(1);
                this.selectedThemes.push({ first: '', second: '' });
            },
            removeExamples(index) {
                this.selectedNumOfExamples.splice(index, 1);
                this.selectedThemes.splice(index, 1);
            },
            changeNumOfExamples(index, sign) {
                const newValue =
                    sign === '+' ? this.selectedNumOfExamples[index] + 1 : this.selectedNumOfExamples[index] - 1;
                this.$set(this.selectedNumOfExamples, index, newValue);
            },
            selectTheme(event, index, position) {
                let value = _.cloneDeep(this.selectedThemes[index]);
                value[position] = event;
                this.$set(this.selectedThemes, index, value);
            },
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            someThemePairsAreEqual() {
                return this.selectedThemes.some(pair => {
                    if (pair && pair.first && pair.second) {
                        return pair.first.key === pair.second.key;
                    }
                    return true;
                });
            },
            someThemesNotSettled() {
                return this.selectedThemes.some(pair => !pair.first || !pair.second);
            },
            themes() {
                if (this.allThemes.length) {
                    return this.allThemes
                        .filter(
                            theme =>
                                theme.type ===
                                this.selectedGameMode.mode.substring(0, this.selectedGameMode.mode.length - 1)
                        )
                        .sort((a, b) => a.name.localeCompare(b.name));
                }
                return [];
            },
            availableNumOfExamples() {
                return Array.from(Array(this.selectedNumOfExamples.length + 1), (_, i) => {
                    return i === this.selectedNumOfExamples.length
                        ? 100 - sum(this.selectedNumOfExamples)
                        : 100 - sum(this.selectedNumOfExamples) + this.selectedNumOfExamples[i];
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field-body--inline {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .form__field-body--inline-md {
        flex-direction: column;
        @include media($md) {
            align-items: baseline;
            flex-direction: row;
            flex: 1 0;
        }
    }

    .remove-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        color: $x-color-black;
        &:hover {
            color: $hsl-color-red-62;
        }
    }

    .form__multiselect-container {
        width: 100%;
        @include media($md) {
            width: auto;
            flex: 1 1 auto;
        }
    }

    .form__multiselect-container:not(:last-child) {
        margin-bottom: 20px;
        @include media($md) {
            margin: 0 10px 0 0;
        }
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>
